import {ebus} from '@/vendor/ebus';

// export const walletEnvironment = 'TEST';
export const walletEnvironment =  'PRODUCTION';

// https://test.saferpay.com/BO/Settings/FieldsAccessToken
export const accessToken = '14762110-7253-4eaa-b2f4-7709cfcdf3fb';
// export const accessToken = 'af1f890f-a8e2-4aeb-94ef-ad674879d1cd';
// for vtest39: af1f890f-a8e2-4aeb-94ef-ad674879d1cd
// for qdev: 29a11d0c-3a1e-400d-87d3-e0d755a14e0d
export const customerId = '365632'; // from backoffice loginname

export const googleGateway = 'worldlinesaferpay';
export const googleGatewayMerchantId = '17774862'; // the terminalId from the backoffice

//merchantId can be found on https://pay.google.com/business/console/
export const googlePayMerchantId = 'BCR2DN4T7XZLXPYV';

// work in progress
